export const CASE_ENDPOINTS = {
  START_CASE: "/v4/twiageCases",
  LOAD_CASE: (caseId: string): string => `/v4/twiageCases/${caseId}?uniquevalue=${Date.now()}&rawDataEnabledTags=true`,
  MODIFY_CASE: (caseId: string): string => `/v4/twiageCases/${caseId}`,
  LOCATION_UPDATE: (caseId: string): string => `/v4/twiageCases/${caseId}/locationUpdates`,
  MEDIA_UPDATE: (caseId: string): string => `/media/twiage-cases/${caseId}/uploads`,
  TAGS: (caseId: string): string => `/v4/twiageCases/${caseId}/tags`,
  DATA_ENABLED_TAGS: (caseId: string, tagId: string): string => `/v4/twiageCases/${caseId}/tags/${tagId}/values`,
  CHAT: (caseId: string): string => `/notification/twiage-cases/${caseId}/chat-messages`,
  LIVE_CONSULT_ROOM: (caseId: string): string => `/notification/twiage-cases/${caseId}/room`,
  CASE_TRANSFER_OPEN: () => `/v4/case-transfers`,
  CASE_TRANSFER_ACCEPT: (caseTransferId: String) => `/v4/case-transfers/${caseTransferId}/accept-request`,
  CASE_TRANSFER_DECLINE: (caseTransferId: String) => `/v4/case-transfers/${caseTransferId}/deny-request`,
  CASE_TRANSFER_CANCEL: (caseTransferId: String) => `/v4/case-transfers/${caseTransferId}/cancel`,
  CASE_TRANSFER_REQUEST: (caseTransferCode: String) => `/v4/case-transfers/${caseTransferCode}/request`,
  CASE_TRANSFER_REQUEST_CANCEL: (caseTransferId: String) => `/v4/case-transfers/${caseTransferId}/cancel-request`,
  CASE_TRANSFER_STATE: (caseTransferId: String) => `/v4/case-transfers/${caseTransferId}`,
  CASE_TRANSFER_RECEIVED: (caseTransferId: String) => `/v4/case-transfers/${caseTransferId}/received`,
  CASE_TRANSFER_ACKNOWLEDGE: (caseTransferId: String) => `/v4/case-transfers/${caseTransferId}/acknowledge`,
  VOIP_TOKEN: (caseId: String) => `/voip/twiage-cases/${caseId}/token`,
  LINK_MONITOR: (caseId: string, manufacturer: string): string => `/monitor-integration/${manufacturer}/${caseId}`,
  DYNAMIC_FORM: (caseId: string, formId: string) => `/v4/twiageCases/${caseId}/dynamicForms/${formId}`,
  FEEDBACK: (caseId: string) => `/v4/twiageCases/${caseId}/case-feedback`,
};
